import Icon from 'veui/components/Icon'
import { IconShoppingBag } from 'dls-icons-vue'

Icon.register('shopping-bag', IconShoppingBag)
